import { useState } from "react";
import { CustomOrderForm } from "../components/CustomOrderForm";
import { LinkRequestForm } from "../components/LinkRequestForm";

const TABS = [
  { id: "custom", label: "Custom order" },
  { id: "link", label: "Send a link" },
];

/**
 * Both request types are open to anyone — there are no accounts. Previously
 * placed requests live on the "My orders" page (this device) and in the link
 * emailed at the time.
 */
export function CustomOrdersPage() {
  const [tab, setTab] = useState(TABS[0].id);

  return (
    <div className="mx-auto max-w-2xl">
      <h1 className="mb-2 text-2xl font-bold text-foreground">Custom Orders</h1>
      <p className="mb-6 text-sm text-muted-foreground">
        Tell us what you want made, or send us a link to something you found. We email
        you a private link to follow it — no account needed.
      </p>

      <div role="tablist" aria-label="Request type" className="mb-6 flex gap-1 border-b border-border">
        {TABS.map((t) => {
          const selected = t.id === tab;
          return (
            <button
              key={t.id}
              type="button"
              role="tab"
              aria-selected={selected}
              onClick={() => setTab(t.id)}
              className={`-mb-px border-b-2 px-4 py-2 text-sm transition-colors ${
                selected
                  ? "border-primary font-medium text-primary"
                  : "border-transparent text-muted-foreground hover:text-foreground"
              }`}
            >
              {t.label}
            </button>
          );
        })}
      </div>

      {tab === "custom" ? <CustomOrderForm /> : <LinkRequestForm />}
    </div>
  );
}

export default CustomOrdersPage;
